const data = [
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	},
	{
		text: 'Built my first node.js app',
		date: 'July 13 2019',
		category: {
			tag: 'medium',
			color: '#ffa31a'
		},
		link: {
			url: 'https://github.com/Dareeben13/DevConnect',
			text: 'Check it out here'
		}
	}
];

export default data;
